/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { Map } from 'immutable';
import { denormalize } from 'normalizr';
import * as schemas from 'data/utils/schemas';
import { loadingProgress, listLoadingProgress } from 'data/reducers/admin/suppliers';

import createImmutableEqualSelector from '../../utils/immutable-selector';

const getState = (state) => state.adminSuppliers;

export const getEntities = (state) => getState(state).get('entities');

export const getItemsList = createImmutableEqualSelector(getEntities, getState, (suppliers, state) =>
  denormalize(state.get('list'), [schemas.supplier], new Map({ suppliers })),
);

export const getItemsListLoaded = (state) => listLoadingProgress.getLoaded(getState(state));
export const getItemsListLoading = (state) => listLoadingProgress.getLoading(getState(state));
export const getItemsListLoadFailed = (state) => listLoadingProgress.getLoadFailed(getState(state));

export const getItemLoaded = (state) => loadingProgress.getLoaded(getState(state));
export const getItemLoading = (state) => loadingProgress.getLoading(getState(state));
export const getItemLoadFailed = (state) => loadingProgress.getLoadFailed(getState(state));

export const getItem = (state) => getState(state).get('sitesSupplier');
